import { supabase } from "@fieldbook/common/supabase"
import { pushNotifications } from "@/platform"

// Best-effort removal of *this* device's push token on logout, so a shared,
// org-owned device stops delivering the signed-out user's pushes before the
// next user signs in and re-registers.
//
// Must run while still authenticated: the RLS DELETE policy scopes to the
// caller's own token row. Only this device's token is removed (not the
// user's other devices), and errors are swallowed — logout must never be
// blocked by push cleanup.
export const unregisterPushDeviceToken = async (): Promise<void> => {
  if (!(await pushNotifications.isSupported())) return
  const token = pushNotifications.getToken()
  if (!token) return
  try {
    await supabase.from("push_device_tokens").delete().eq("token", token)
  } catch (err) {
    console.warn("Failed to unregister push device token:", err)
  }
}
